module.exports = __webpack_public_path__ + "static/media/red-pay-logo.d84f2cb5.png";